import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class ContractService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }
  getContracts(
    pageIndex: number,
    sortDirection?: string,
    sortProperty?: string,
    tipoContrato?: string,
    entidade?: string,
    numeroContrato?: string,
    dataInicio?: string,
    dataFinal?: string,
    status?: string,
    nomeContrato?: string,
    numeroEdital?: string,
    prorrogavelAte?: string,
    medida?: string,
    dataAssinaturaInicio?: string,
    dataAssinaturaFinal?: string,
    dataEficaciaInicio?: string,
    dataEficaciaFinal?: string,
    nameOrContractNumberFilter?: string,
     pageSize?: number,
  ) {

    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize?.toString() || '10')
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('contractTypeName', tipoContrato || '')
      .set('contractNumber', numeroContrato || '')
      .set('status', status || '')
      .set('contractName', nomeContrato || '')
      .set('extendableUntil', prorrogavelAte || '')
      .set('companyCorporateName', entidade || '')

    if (dataInicio) {
      params = params.set('startDate', dataInicio);
    }
    if (dataFinal) {
      params = params.set('endDate', dataFinal);
    }
    if (dataAssinaturaInicio) {
      params = params.set('startSignatureDate', dataAssinaturaInicio);
    }
    if (dataAssinaturaFinal) {
      params = params.set('endSignatureDate', dataAssinaturaFinal);
    }
    if (dataEficaciaInicio) {
      params = params.set('startEffectivenessDate', dataEficaciaInicio);
    }
    if (dataEficaciaFinal) {
      params = params.set('endEffectivenessDate', dataEficaciaFinal);
    }
    if (medida) {
      params = params.set('measureExtendableUntil', medida);
    }
    return this.http.get(this.baseUrl + `/v1/contracts`, { params });
  }

  getContractsActives(
    pageIndex: number,
    sortDirection?: string,
    sortProperty?: string,
    tipoContrato?: string,
    entidade?: string,
    numeroContrato?: string,
    dataInicio?: string,
    dataFinal?: string,
    status?: string,
    nomeContrato?: string,
    numeroEdital?: string,
    prorrogavelAte?: string,
    medida?: string,
    dataAssinaturaInicio?: string,
    dataAssinaturaFinal?: string,
    dataEficaciaInicio?: string,
    dataEficaciaFinal?: string,
    nameOrContractNumberFilter?: string,
    pageSize?: number
  ) {

    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize?.toString() || '10')
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('contractTypeName', tipoContrato || '')
      .set('contractNumber', numeroContrato || '')
      .set('status', status || '')
      .set('contractName', nomeContrato || '')
      .set('extendableUntil', prorrogavelAte || '')
      .set('companyCorporateName', entidade || '')

    if (dataInicio) {
      params = params.set('startDate', dataInicio);
    }
    if (dataFinal) {
      params = params.set('endDate', dataFinal);
    }
    if (dataAssinaturaInicio) {
      params = params.set('startSignatureDate', dataAssinaturaInicio);
    }
    if (dataAssinaturaFinal) {
      params = params.set('endSignatureDate', dataAssinaturaFinal);
    }
    if (dataEficaciaInicio) {
      params = params.set('startEffectivenessDate', dataEficaciaInicio);
    }
    if (dataEficaciaFinal) {
      params = params.set('endEffectivenessDate', dataEficaciaFinal);
    }
    if (medida) {
      params = params.set('measureExtendableUntil', medida);
    }
    return this.http.get(this.baseUrl + `/v1/contracts/actives`, { params });
  }

  getContractType() {
    return this.http.get(
      this.baseUrl +
      `/v1/type-contracts
      `
    );
  }


  calcFinalDate(data: any) {
    return this.http.post(
      this.baseUrl +
      `/v1/contracts/calculate-end-date
      `
      , { ...data });

  }

  getContract(contractId: string | null) {
    return this.http.get(this.baseUrl + `/v1/contracts/${contractId}`);
  }
  getHistoryContract(contractId: string | null, pageIndex:number = 0) {
    return this.http.get(this.baseUrl + `/v1/contracts/${contractId}/history?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`);
  }
  
  createContract(data: any) {
    return this.http.post(this.baseUrl + `/v1/contracts`, { ...data });
  }
  updateContract(data: any, contractId: any) {
    return this.http.put(this.baseUrl + `/v1/contracts/${contractId}`, { ...data });
  }

  activate(contractId: number) {
    return this.http.patch(this.baseUrl + `/v1/contracts/${contractId}/activate`, {});
  }

  inactivate(contractId: number) {
    return this.http.patch(this.baseUrl + `/v1/contracts/${contractId}/inactivate`, {});
  }


  deleteContract(contractId: string) {
    return this.http.delete(this.baseUrl + `/v1/contracts/${contractId}`);
  }

  getPrazoAnaliseProjeto(contractId: string | null) {
    return this.http.get(this.baseUrl + `/v1/contracts/${contractId}/prazo-analise-projeto`);
  }

  savePrazoAnaliseProjeto(contractId: string | null, data: any) {
    return this.http.put(this.baseUrl + `/v1/contracts/${contractId}/prazo-analise-projeto`, data);
  }

  getHistoryPrazoAnaliseProjeto(contractId: string | null, pageIndex: number = 0) {
    const params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('size', '10')
      .set('sortField', 'data')
      .set('sortDirection', 'desc')
      .set('author', '')
      .set('startDate', '')
      .set('endDate', '');
    return this.http.get(this.baseUrl + `/v1/contracts/${contractId}/prazo-analise-projeto/historico`, { params });
  }
}
